import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const fetchAdvancedSurveyResponses = async ({ photoSessionId }) => {
  const token = localStorage.getItem("token");

  const res = await axios.get(`${__API_URL__}/api/survey/advanced-survey-responses/`, {
    params: { photo_session_id: photoSessionId },
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data || [];
};

const useGetAdvancedSurveyResponses = ({ photoSessionId, enabled = true }) => {
  return useQuery({
    queryKey: ["advanced-survey-responses", photoSessionId],
    queryFn: () => fetchAdvancedSurveyResponses({ photoSessionId }),
    enabled: enabled && Boolean(photoSessionId),
  });
};

export default useGetAdvancedSurveyResponses;
